
import layerEvents from "../utils/layerEvents";
import { Button, Col, Row, Dropdown, Form} from "react-bootstrap";
import Select from "react-select";
import { PencilSimple,Lightning, Windmill, BatteryCharging, BatteryFull, Spiral, Ruler, Crosshair, X, Info, Eye, Trash, DotsThreeVertical, Wind, Calculator, Warning, CircleNotch, Plus, Bulldozer,ArrowsOutLineVertical,ArrowsOutLineHorizontal, CarProfile   } from "@phosphor-icons/react";
import DataTable from 'react-data-table-component';
import atlasApi from "../utils/atlasapi";
import {format_power} from "../utils/functions";
import EditNow from "../components/EditNow";
import DoNowButton from "../components/DoNowButton";
import ReactDOM from "react-dom/client";
import roadMode from "../utils/roadMode";
import TurfArea from '@turf/area';
import TurfBuffer from '@turf/buffer';
import TurfLength from '@turf/length';
import {formatArea, formatDistance} from "../utils/functions";
import PowerRoadsPanel from "../components/PowerRoadsPanel";
import LayerRoad		from "../classes/LayerRoad";
import drawTheme from "../utils/drawUtilsTheme";
import Tool						from "../classes/Tool";


class ToolRoad extends Tool  {

	tabIndex			= null;
	highlightedOnList	= [];
	
	turbineTypes		= [];
	turbineHeights		= [];
	modified			= false;
	contextMenu			= null;
	lastSelection		= null;
	
	type				= 'road'
	itemsName			= 'roads';
	id					= 'roadid';
	infolayerId			= 'roads';
	constructor(p, viewMode) {
		super();
		this.parent = p;
		this.draw	= p.draw.draw;
		this.tc		= p;
		this.view	= viewMode;
		this.getHiddenItems();
	}
	init(){
		Tool.prototype.init.call(this);
		this.display();
		this.setEventHandlers();
		this.tc.map.getContainer().classList.add("cursor-road");
		this.stackDrawLayers();
	}
	exit(){
		
		if(this.parent.serviceBar.current)
			this.parent.serviceBar.current.clear(this.tabIndex);
		this.tabIndex = null;
		this.removeEventHandlers();
		
		this.tc.map.getContainer().classList.remove("cursor-road");
		this.tc.map.getContainer().classList.remove("cursor-pointer");
		
	}

	getToolLayer = () => {
		return LayerRoad;
	}
	stackDrawLayers = () =>{
		
		drawTheme.forEach((l)=>{
			if(this.tc.map.getLayer(l.id+".cold"))
				this.tc.map.moveLayer(l.id+".cold");
			if(this.tc.map.getLayer(l.id+".hot"))
				this.tc.map.moveLayer(l.id+".hot");
		});
		
	}
	setEventHandlers(){
		
		if(!this.parent)
			return;
		
		if(!this.parent)
			return;
		Tool.prototype.setEventHandlers.call(this);
		this.tc.map.on('click', this.handleClick);
		
		this.tc.map.on('draw.update', this.handleUpdate);
		
		this.tc.map.on('mouseenter', [LayerRoad.outlineId], this.handleMouseEnter);
		this.tc.map.on('mouseleave', [LayerRoad.outlineId], this.handleMouseLeave);
		
		this.tc.map.on('mouseenter', [LayerRoad.outlineId], this.handleCursorChange);
		this.tc.map.on('mouseleave', [LayerRoad.outlineId], this.handleCursorChange);
		
	}
	removeEventHandlers(){
		if(!this.parent)
			return;
		Tool.prototype.removeEventHandlers.call(this);
		this.tc.map.off('click', this.handleClick);
		this.tc.map.off('draw.update', this.handleUpdate);
		
		this.tc.map.off('mouseenter', [LayerRoad.outlineId], this.handleMouseEnter);
		this.tc.map.off('mouseleave', [LayerRoad.outlineId], this.handleMouseLeave);
		
		
		this.tc.map.off('mouseenter', [LayerRoad.outlineId], this.handleCursorChange);
		this.tc.map.off('mouseleave', [LayerRoad.outlineId], this.handleCursorChange);
	}
	handleClick = (e) => {
		
		if(this.tc.secondaryHandler)
			return;
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerRoad.outlineId]});
		
		if(this.tc.handler.constructor.name == "ToolRoadAdd")
			return;
		
		
		var clickedRoad = features && features[0] ? features[0].properties.roadid : 0;
		if(this.view && !clickedRoad)
			return;
		this.exit();
		this.tc.handler = new ToolRoadAdd(this.tc, clickedRoad);
		this.tc.handler.init(e);
		
	}
	handleCursorChange = (e)=>{
		this.tc.map.getContainer().classList[e && e.type == 'mouseenter' ? 'add' : 'remove']("cursor-pointer");
		
	}
	handleMouseEnter = (e)=>{
		if(!e.features.length)
			return;
		
		var roadId = e.features[0].properties.roadid;
		


		var idx = this.tc.scenario.roads.findIndex((p)=>{
			return p.roadid == roadId || (p.properties && p.properties.tempid == roadId);
		});

		if(idx>-1){
			this.highlightedOnList = [roadId];
			///check if it's close to endpoints
			const geo = structuredClone(this.tc.scenario.roads[idx].geometry);
			geo.coordinates = geo.type == "MultiLineString" ? geo.coordinates[0] : geo.coordinates;
			var ends = [
				geo.coordinates[0], 
				geo.coordinates[geo.coordinates.length-1]
			]

			//this.addHandles(ends, roadId);
		}

		
		this.display();
	}
	handleMouseLeave = (e)=>{
		this.highlightedOnList = [];
		this.removeHandles();
		this.display();
	}
	
	
	
	addHandles(points, roadId){
		
		const handles = points.map((p, idx)=>{
			return {
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": p
				},
				"properties" : {
					"roadid" : roadId,
					"position" : idx+1
				}
			}
		});
				
		this.removeHandles();
		this.tc.map.addSource(this.type+'_handles', {
			type: 'geojson',
			data: {
				type: 'FeatureCollection',
				features: handles
			}
		});

		this.tc.map.addLayer({
			id: this.type+'_handle_circles',
			type: 'circle',
			source: this.type+'_handles',
			paint: {
				'circle-color': "#ff0000",
				'circle-radius': 10,
			}
		});
	}
	removeHandles(){
		const l = this.type+'_handle_circles';
		const b = this.type+'_handles';
		if(this.tc.map.getLayer(l)){
			this.tc.map.removeLayer(l);
		}
		if(this.tc.map.getSource(b)){
			this.tc.map.removeSource(b);
		}
	}
	highlightOnMap = (row)=>{
		
		this.tc.map.setFeatureState({id:100000000+this.getId(row), source:'rd_source'}, {hover:true});
		
	}
	deHighlightOnMap = (row)=>{
		
		this.tc.map.setFeatureState({id:100000000+this.getId(row), source:'rd_source'}, {hover:false});
		
	}
	handleEdit(row){
		
		if(!row.roadid && !row?.properties?.tempid)
			return;
		
		const roadId = this.getId(row);
		this.toggleItem(roadId, false); //false == not invisible
		
		setTimeout(()=>{
			this.exit();
			this.tc.handler = new ToolRoadAdd(this.tc, roadId);
			this.tc.handler.selected = this.selected;
			this.tc.handler.init();
			
		}, 50);
		
		
	}
	handleCreate = (e) => {
		//it's a new boundary polygon
		if (e.features && e.features[0].id){
			ToolRoad.lastSelection = {id: e.features[0].id, type: e.features[0].properties.type}
			this.handleUpdate(e, e.features[0].id);
		}
	
		
		this.exit(true);
		
		this.roadModeForce();
		//const rId = this.tc.scenario.roads[this.tc.scenario.roads.length-1].properties.tempid;
		
		
		//this.handleEdit({roadid:rId});	
		
	}
	handleForceCreate = () => {

		var feature = this.draw.get('added_road');
		if (feature && feature.geometry.coordinates.length > 2){
			ToolRoad.lastSelection = {id: feature.id, type: feature.properties.type}
			ToolRoad.forcedClose = true;
			this.handleUpdate(null, feature.id);
		}
		else if (feature && feature.geometry.coordinates.length < 3)
			this.draw.changeMode('simple_select');
	}
	handleDelete = (e) => {
		if (e.features && e.features[0].id ){
			this.handleUpdate(e, e.features[0].id, true);
		}
		ToolRoad?.currentObj?.exit();
	}
	handleDeleteFromList(e, roadId){
		this.handleUpdate(e, roadId, true);
		this.resetLayer();
	}
	handleSelect = (e, row) => {
		const id = "roadid";
		if(!this.selected)
			this.selected = [];
		const idx = this.selected.findIndex((a)=>{return this.getId(a) == this.getId(row)});
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}
	handleSelectAll = () => {
		if (!this.selected) this.selected = [];
		const items = (this.parent.scenario.roads ?? []).filter(t => !!t.geometry);
		const allSelected = items.length > 0 && items.every(d => this.selected.some(s => this.getId(s) === this.getId(d)));
		if (allSelected) { this.selected = []; } else { this.selected = items.slice(); }
		this.display();
	}
	removeItem = (id) => {
		const s = this.tc.scenario;
		const idx = s.roads.findIndex(p => p.roadid == id || p?.properties?.tempid == id);
		if (idx > -1) {
			delete s.roads[idx].geometry;
			s.modified = 1;
			this.tc.setScenario(s);
		}
	}

	bulkDeleteApi = (ids) => atlasApi.bulkDeleteRoads(this.tc.scenario.projectid, this.tc.scenario.scenario_id, ids).then(() => this.tc.refreshProperties());

	afterBulkDelete = (count) => {
		const {QN} = this.tc.draw.context;
		QN.current.show("Deleted " + count + " roads", <Button variant="primary btn-sm" onClick={() => { this.tc.undo(count); }}>Undo</Button>);
	}
	handleDeleteFromPanel = (e)=>{
		if(this.draw.getMode() == 'road_mode'){
			this.draw.delete('added_road');
		}
		if(ToolRoad.lastSelection){
			this.handleDeleteFromList(e, ToolRoad.lastSelection.id);
		}
		this.exit(true);
		this.roadModeForce();
	}
	handleUpdate = (e, pl, del) => {
		
		if(e && e.action == 'move')
			return;
		//check for road update
		var npl = null;
		var self = this;
		
		var nplid = pl ? parseInt(pl.toString().replace(/^\D+/g, '')) : e.features[0].id.toString().replace(/^\D+/g, '');
		
		if(del)
			npl = {properties:{roadid:nplid} };

		if(del || (npl = this.draw.get(pl ?? e.features[0].id))){
			
			var s = {...this.tc.scenario};
			if(npl.properties.roadid || npl.properties.tempid) {
				
				var idx = s.roads.findIndex((p)=>{
					return p.roadid == nplid || (p.properties && p.properties.tempid == nplid);
				});

				if(idx>-1){
					if(del){
						const realId = s.roads[idx].roadid;
						delete s.roads[idx].geometry;
						if(!isNaN(realId)){
							const pId = s.projectid;
							const sId = s.scenario_id;
							this.save(atlasApi.deleteRoad(pId, sId, realId).then(() => this.tc.refreshProperties()));
						}
					}
					else if(npl.geometry){
						s.roads[idx].geometry = npl.geometry;
						const realId = s.roads[idx].roadid;
						if(!isNaN(realId)){
							const pId = s.projectid;
							const sId = s.scenario_id;
							this.save(atlasApi.updateRoad(pId, sId, realId, {geometry: npl.geometry}).then(() => this.tc.refreshProperties()));
						}
					}
				}
				if(npl.properties.tempid)
					delete npl.id;
			}
			else {
				delete npl.id;
				const tempid = Math.floor(1000000 + Math.random() * 10000000);
				npl.properties = {tempid};
				npl.width = this.obj.width;
				npl.name = this.obj.name;
				if(ToolRoad.forcedClose){
					npl.geometry.coordinates.pop();
					delete ToolRoad.forcedClose;
				}
				s.roads.push(npl);
				const pId = s.projectid;
				const sId = s.scenario_id;
				this.save(
					atlasApi.createRoad(pId, sId, { geometry: npl.geometry, name: npl.name, width: npl.width, color: npl.color }).then((res) => {
						const created = Array.isArray(res) ? res[0] : res;
						if(created?.id){
							const sc = {...this.tc.scenario};
							const i = sc.roads.findIndex(r => r.properties?.tempid == tempid);
							if(i > -1) {
								sc.roads[i].roadid = created.id;
								delete sc.roads[i].properties.tempid
							}
							this.tc.setScenario(sc);
							this.resetLayer();
						}
						this.tc.refreshProperties();
					})
				);
			}

			s.modified = 1;

			this.tc.setScenario(s);
		}
	}
	handleSelectionChange = (e) => {	
		//var features = this.map.queryRenderedFeatures(e.point);
		if(!this.parent || !this.parent.scenario || !this.parent.scenario.scenario_id //check if is main scenario
		){
			this.parent.draw.draw.changeMode('simple_select');
		}
		//check if road is deselected or a diferent road
		
		if (ToolRoad.lastSelection && (!e.features.length || e.features[0].id != ToolRoad.lastSelection.id)){
			this.finishLastEdit();
		}
		//check if road is selected
		if (e.features.length && e.features[0].properties && ['powerline', 'road'].includes(e.features[0].properties.type) ){
			ToolRoad.lastSelection = {id: e.features[0].id, type: e.features[0].properties.type};
			return;
		}

	}
	
	finishLastEdit(e){
		if (ToolRoad?.lastSelection?.id){
			this.handleUpdate(e, ToolRoad.lastSelection.id);
			
		}
		ToolRoad?.currentObj?.exit();
	}
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(parseInt(id));
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		
		this.display();
	}
	deHighlightOnList = (id) => {

		const index = this.highlightedOnList.indexOf(parseInt(id));
		if (index > -1) { 
			this.highlightedOnList.splice(index, 1); 
		}
		this.display();
	}

	pName(row, index){
		return row.name ? row.name : 'Road '+ (index+1);
		
	}
	handleUpdateName = (val, roadId) => {
		
		var s = {...this.tc.scenario};
		

		var idx = s.roads.findIndex((p)=>{
			return p.roadid == roadId || (p.properties && p.properties.tempid == roadId);
		});

		if(idx>-1){
			s.roads[idx].name = val;
			const realId = s.roads[idx].roadid;
			if(!isNaN(realId)){
				this.save(atlasApi.updateRoad(s.projectid, s.scenario_id, realId, {name: val}).then(() => this.tc.refreshProperties()));
			}
		}
		this.resetLayer();
		//issue exit command to refresh viewport (weird bug not deleting the pl linestring


		s.modified = 1;

		this.tc.setScenario(s);
	}
	setHideAll(value){
		this.allHidden = value;
		this.display();
	}

	getId(item){
		return item.roadid ?? item?.properties?.tempid;
	}

	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(this.getId(row));
	}
	
	contextMenuAdd(map_event){
		return (
			<button className="btn" onClick={(e)=>{this.parent._addTurbineHandler(map_event); this.closeContextMenu();}}><Plus size={20} /> Add Road</button>
		);
	}
	contextMenuDelete(map_event){
		return (
			<button className="btn" onClick={(e)=>{this.parent._remTurbineHandler(map_event); this.closeContextMenu();}}><Trash size={20} /> Remove Road</button>
		);
	}
	
	calculate(p){
		
		p.width = isNaN(p.width) ? 0 : p.width;
			
		if(!p.geometry || !p.geometry.coordinates.length){
			p.length = 0;
			p.area = 0;
		}
		else {
			p.length = TurfLength({...p, ...{type:'Feature'}}, { units: 'meters' });
			p.area = p.width ? TurfArea(TurfBuffer({...p, ...{type:'Feature'}}, p.width/2, { units: 'meters'})) : 0;
		}
		return p
	}

	toggleItem(item_id, f, dontRefresh){
		
		const extra = (_item_id, force, hide) => {

			this.tc.map.setFeatureState(
				{
					source: this.getToolLayer().sourceId,
					id: this.getToolLayer().generateBufferId(_item_id)
				},
				{
					invisible:(force != 'undefined' ? force : hide)
				}
			);
		}
		
		super.toggleItem(item_id, f, dontRefresh, extra);
		
	}
	removeFeature(id){
		var data = this.tc.map.getSource('rd_source')._options.data;
		//remove the original line
		var idx = data.features.findIndex((p)=>{return p.id == id});
		if(idx>-1)
			data.features.splice(idx, 1);
		//remove the original buffer
		var idx = data.features.findIndex((p)=>{return p.bufferid == id});
		if(idx>-1)
			data.features.splice(idx, 1);
		
		
		this.tc.map.getSource('rd_source').setData(data);
	}
	resetLayer = ()=>{
		this.tc.infoLayers.current.resetSystemLayer("roads");
		
	}
	update(){
		this.resetLayer();
	}
	
	listRoads(){
		const {getters} = this.parent.draw.context;
		
		var lines = this.parent.scenario.roads.filter((t) => t.geometry ? true : false).map(this.calculate);
		
		return (
			<>
				<DataTable
					data={lines}
					columns={
						[
							{
								name:<Eye onClick={()=>{this.handleHideAllItems()}} className={""+(this.areAllHidden() ? 'opacity-25' : '')} size={16} />,
								id:'userid',
								selector: row => row.userid,
								format: (row) =>	(<Eye onClick={(e)=>{this.handleToggleItem(e, this.getId(row), undefined, false)}} id={"bndr_"+this.getId(row)} data-id={this.getId(row)}  className={""+(this.hiddenItems.includes(row.roadid) || this.allHidden ? 'opacity-25' : '')} size={16} />),

								width:"28px !important",
								style: {
									padding: '0',
								}
							},
							{
								name:(
									<Form.Check
										type="checkbox"
										checked={!!(this.parent.scenario.roads?.filter(t=>!!t.geometry).length) && this.parent.scenario.roads.filter(t=>!!t.geometry).every(d => this.selected && this.selected.some(s => this.getId(s) === this.getId(d)))}
										ref={el => { if (el) el.indeterminate = !!(this.selected?.length) && this.selected.length < (this.parent.scenario.roads?.filter(t=>!!t.geometry).length ?? 0); }}
										onChange={this.handleSelectAll}
									/>
								),
								selector: row => row.name,
								format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+this.getId(row)} checked={this.selected && this.selected.some((a)=>this.getId(a) == this.getId(row))} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
								width:"25px",
								style: {
									padding: '0px !important',
									width:'25px'
								}
							},
							{
								name:'NAME',
								selector: (row,index) => {return row.name},
								format: (row,index) => (<EditNow id={'road-'+this.getId(row)} value={this.pName(row,index)} onClick={(e)=>{this.handleEdit(row)}} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, this.getId(row))}} />),
								sortable:true,
								width:"100%",
							},
							{
								name:'Length',
								selector: row => row.length,
								format: (row,index) => formatDistance(row.length),
								sortable:true,
								width:"100%",
								style: {
									textAlign:'center'
								}
							},
							{
								name:'Width',
								selector: row => row.width,
								format: (row,index) => {return formatDistance(row.width)},
								sortable:true,
								width:"45px",
								style: {
									textAlign:'center'
								},
							},
							{
								name:'Affected',
								selector: row => row.area,
								format: (row,index) => {return formatArea(row.area, getters.user)},
								sortable:true,
								width:"100%",
								style: {
									textAlign:'center'
								},
							},

							{
								name:'',
								cell: row => (
									<div className="context-menu" data-tag="allowRowEvents">
											<Dropdown className="minimal">
												<Dropdown.Toggle className="p-0 px-1" variant="default">
													<DotsThreeVertical size={16} />
												</Dropdown.Toggle>
												<Dropdown.Menu>
													<Dropdown.Item href="#" onClick={(e)=>{ this.handleEdit(row);   }}><PencilSimple size={16} /> Edit road</Dropdown.Item>
													<Dropdown.Item href="#" onClick={(e)=>{ this.handleDeleteFromList(e, this.getId(row)); }} className="text-danger" ><Trash size={16} /> Remove road</Dropdown.Item>
												</Dropdown.Menu>
											</Dropdown>
									</div>
								),
								width:"20px !important",
								style:{
								}
							}
						]
					}
					customStyles={{
						headCells:{
							style: {
								padding:'.5rem .3rem',
								minWidth:'0px !important',
								boxSizing:'content-box',
								fontWeight:'bold'
							}
						},
						cells:{
							style: {
								padding:'.5rem .3rem',
								minWidth:'0px !important',
								boxSizing:'content-box',
								fontSize: 'var(--bs-body-font-size);',
								color:'var(--bs-body-color)',
								'&:last-child':{paddingRight:'1rem'}
							}
						},
						rows:{
							style: {
								minHeight:"0",
							},
							selectedHighlightStyle:{
								backgroundColor:'red'
							}
						}
					}}
					onRowMouseEnter={this.highlightOnMap}
					onRowMouseLeave={this.deHighlightOnMap}
					onRowClicked={(row)=>this.handleEdit(row) }
					selectableRowSelected={r=>this.isSelectedOnList(r)}
					highlightOnHover
					selectableRowsHighlight
					pointerOnHover
					sortIcon={<i className="ri-expand-up-down-line" />}
					noDataComponent={

						<Row className="p-0 py-3 m-0">

							<Col xs="1 pe-0">
								<Info className="text-danger" size={15} />
							</Col>
							<Col xs="11 ps-0">
								<b>Please note:</b> There are currently no roads placed in this scenario.
							</Col>



						</Row>
					}
					className="toolRoad"
				/>


				{this.selected && !!this.selected.length &&
					<Row className="p-3 batch-action">
						<Col xs="6">
							{this.selected.length} Items selected
						</Col>
						<Col xs="6 text-end">
							<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
						</Col>
					</Row>
				}
				{!!lines.length &&
				<Row className="p-2 totals">
					<Col xs="2">
						Total
					</Col>
					<Col xs="2">
						{lines.length}
					</Col>
					<Col xs="3 text-center">
						{formatDistance(lines.reduce((t, c) => {return t + c.length; }, 0), getters.user) }
					</Col>

					<Col xs="1 text-end pe-0">

					</Col>
					<Col xs="3 text-center">
						{formatArea(lines.reduce((t, c) => {return t + c.area; }, 0), getters.user) }
					</Col>

					<Col xs="1 text-end pe-0">

					</Col>
				</Row>
				}
			</>
		);
	}
	
	render(){
		
		return (
			
			<div className={"project-roads "}>
				<div className="title">
					Roads
					{/*<span onClick={(e)=>{this.parent.exit()}} 	className="btn btn-close alt float-end"><X size={16} /></span>*/}
				</div>
				<div className="scroll">
					<div className="content p-0">

						{this.listRoads()}
					</div>

				</div>
			</div>

		);
	
	}
}

class ToolRoadAdd extends ToolRoad {

	tabIndexAdd = null;
	roadId = 0;
	mapPanPadding = 50;
	moveSpeed = 10;
	
	constructor(p, roadId) {
		super(p);
		//this.tc = this.parent.parent;
		this.scenario = this.tc.scenario;
		this.draw = this.tc.draw.draw;
		this.roadId = roadId;
		this.get();
		this.area = 0;
		this.length = 0;
		
		return this;
	}
	
	get(){
		const idx = this.scenario.roads.findIndex((p)=>{
			return p.roadid == this.roadId || (p.properties && p.properties.tempid && p.properties.tempid == this.roadId);
		});
		
		if(idx > -1){
			
			this.objIdx = idx;
			this.obj = this.scenario.roads[idx];
			
			if(!this.obj.width)
				this.obj.width = LayerRoad.defaultWidth;
			if(!this.obj.color)
				this.obj.color = LayerRoad.defaultColor;
			if(!this.obj.name)
				this.obj.name = 'Road '+(this.scenario.roads.length+1)
			
		}
		else{
			this.obj = {
				name: 'Road '+(this.scenario.roads.length+1),
				width: LayerRoad.defaultWidth,
				color: LayerRoad.defaultColor
			}
		}
		
	}
	loadRoad(roadId){
		//find clicked road 
		if(!this.roadId)
			return;
		
		var pl = JSON.parse(JSON.stringify(this.obj));

		pl.id = 'road_'+this.roadId;
		pl.type = 'Feature';
		pl.properties = {...pl.properties, ...{
			type:'road', 
			roadid: this.roadId
		}};
		if(!pl.properties.width)
			pl.properties.width = this.obj.width ? this.obj.width :   this.defaultWidth;
		if(!pl.properties.color)
			pl.properties.color = this.obj.color ? this.obj.color :  this.defaultColor;
		
		
		if(pl.geometry.type == "MultiLineString"){
			pl.geometry.type = "LineString"
			pl.geometry.coordinates = pl.geometry.coordinates[0];
		}
		
		

		this.draw.add(pl);
		
		ToolRoad.lastSelection = {id: pl.id, type: this.type};
		this.draw.changeMode('simple_select', { featureIds: [pl.id] });
		this.draw.changeMode('direct_select', {
			featureId: pl.id,
			coordPath: "0",
			startPos: pl.geometry.coordinates[0]
		});
		
		this.removeFeature(this.roadId);
		//super.removeHandles();
		
		this.stackDrawLayers();
		this.calculate();
	}
	
	init(e){
		var handles = [];//e ? this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerRoad.handlesId]}) : [];
		
		//this.configBox();
		
		if(this.tc.serviceBar.current)
			this.tabIndexAdd = this.tc.serviceBar.current.inject(this.render());
		
		this.tc.map.getContainer().classList.add("cursor-road");
		this.draw.changeMode('simple_select', { featureIds: [] });
		this.addBufferLayer();
		if(this.roadId && !handles.length){
			this.loadRoad();
		}
		else{
			
			this.draw.changeMode('road_mode', {
				roads: this.tc.scenario.roads,
				toolRoad: this,
				startCoordinate: [e.lngLat.lng, e.lngLat.lat],
				handles: handles
			});
			if(handles.length)
				this.removeFeature(handles[0].properties.roadid);
		}
		this.setEventHandlers();
		this.openDrawPanel();
		this.display();
		
	}
	configBox(){
		
		this.mapProps = this.tc.map.getContainer().getBoundingClientRect();
		this.hCenter = this.mapProps.width/2;
		this.vCenter = this.mapProps.height/2;
		
		this.lPad = this.mapPanPadding;
		this.rPad = this.mapProps.width - this.mapPanPadding;

		this.tPad = this.mapPanPadding;
		this.bPad = this.mapProps.height - this.mapPanPadding;
		
	}
	exit(soft){
		
		var forced = false;

		if(this.draw.getMode() == 'road_mode' && !soft){
			this.handleForceCreate();
			forced = true;
		}	
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tabIndexAdd);
		this.removeEventHandlers();
		this.tc.map.getContainer().classList.remove("cursor-road");
		this.tc.map.getContainer().classList.remove("cursor-intersection");
		this.closeDrawPanel();
		this.removeBufferLayer();
		this.removeDrawLayer();
		this.resetLayer();
		this.tabIndexAdd = null;
		this.objIdx = null;
		ToolRoad.lastSelection = null;
		

	}
	setEventHandlers(){
		
		if(!this.tc)
			return;
		
		this.removed = 1;
		
		this.tc.map.on('draw.create', this.handleCreate);
		this.tc.map.on('draw.delete', this.handleDelete);
		this.tc.map.on('draw.selectionchange',	this.handleSelectionChange);
		this.tc.map.on('draw.update', this.handleUpdate);
		this.tc.map.on('draw.modechange', this.handleModeChange);
		this.tc.map.on('draw.updatevertex', this.handleUpdateVertex);
		
		this.tc.map.on('mousemove',		this.calculate);
		//this.tc.map.on('mousemove',		this.handleMove);

		this.tc.map.on('mouseenter',	[LayerRoad.bufferId], super.handleMouseEnter);
		this.tc.map.on('mouseleave',	[LayerRoad.bufferId], super.handleMouseLeave);
		
		//this.tc.map.on('mouseenter',	[LayerRoad.bufferId], this.handleCursorChange);
		//this.tc.map.on('mouseleave',	[LayerRoad.bufferId], this.handleCursorChange);
		
		
	}
	removeEventHandlers(){
		if(!this.parent || !this.removed)
			return;
		this.removed = 0;
		
		this.tc.map.off('draw.create', this.handleCreate);
		this.tc.map.off('draw.delete',	this.handleDelete);
		this.tc.map.off('draw.selectionchange',	this.handleSelectionChange);
		this.tc.map.off('draw.update', this.handleUpdate);
		this.tc.map.off('draw.modechange', this.handleModeChange);
		this.tc.map.off('draw.updatevertex', this.handleUpdateVertex);
		
		this.tc.map.off('mousemove',	this.calculate);
		//this.tc.map.off('mousemove',	this.handleMove);
		
		this.tc.map.off('mouseenter',	[LayerRoad.bufferId], super.handleMouseEnter);
		this.tc.map.off('mouseleave',	[LayerRoad.bufferId], super.handleMouseLeave);
		
		//this.tc.map.off('mouseenter',	[LayerRoad.bufferId], this.handleCursorChange);
		//this.tc.map.off('mouseleave',	[LayerRoad.bufferId], this.handleCursorChange);
		
		super.removeEventHandlers();
		
	}
	roadModeForce = () => {
		
		this.tc.handler = new ToolRoad(this.tc);
		this.tc.handler.selected = this.selected;
		this.tc.handler.init();
		
	}
	handleClick = ()=>{
		
	}
	handleUpdateVertex = (e) =>{
		
		var s = {...this.tc.scenario};
		const roadId = parseInt(e.featureId.toString().replace(/^\D+/g, ''));

		
		var data = this.tc.map.getSource('rd_source')._options.data;
		
		
		e.oldCoords.forEach((oldCoord) => {

			data.features.forEach((p, pIdx)=>{
				if(p.roadid == roadId || !p.geometry)
					return;

				const points = p.geometry.type == "MultiLineString" ? p.geometry.coordinates[0] : p.geometry.coordinates;
				var found = false;
				points.forEach((coord, idx)=>{
					if(coord[0] == oldCoord[0] && coord[1] == oldCoord[1]){
						points[idx] = e.newCoords;
						found = true;
					}
				});
				if(found){
					//replace buffer
					var buff = TurfBuffer(p, p.properties.width/2, { units: 'meters'});
					buff.bufferid = p.id;
					buff.id = 100000000+p.id;
					buff.properties.roadid = p.id;
					
					var bIdx = data.features.findIndex((b)=>{return b.bufferid == p.id});
					if(bIdx>-1){
						data.features[bIdx] = buff;
					}
					
					var pl = this.tc.scenario.roads.find((pl)=>{return pl.roadid == p.roadid});
					pl.geometry = p.geometry;
				}
				

			});
			
		});
		this.tc.map.getSource('rd_source').setData(data);
		
		//this.tc.draw.drawroadsLines(s);
	}
	closeDrawPanel() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".roadModePanel")){
			a.remove();
		}
		
		
	}
	addBufferLayer(){
		this.removeBufferLayer();
		this.tc.map.addSource(this.type+'_buffer', {
			type: 'geojson',
			data: {
				type: 'FeatureCollection',
				features: []
			}
		});

		this.tc.map.addLayer({
			id: this.type+'_buffer-fill',
			type: 'fill',
			source: this.type+'_buffer',
			paint: {
				'fill-color': this.obj.color,
				'fill-opacity': 0.3
			}
		});
		this.tc.map.moveLayer(this.type+'_buffer-fill', 'gl-draw-polygon-and-line-vertex-stroke-inactive.cold');
	}
	removeBufferLayer(){
		const l = this.type+'_buffer-fill';
		const b = this.type+'_buffer';
		if(this.tc.map.getLayer(l)){
			this.tc.map.removeLayer(l);
		}
		if(this.tc.map.getSource(b)){
			this.tc.map.removeSource(b);
		}
	}
	removeDrawLayer(){
		if(ToolRoad.lastSelection && this.draw.get(ToolRoad.lastSelection.id)){
			let id = ToolRoad.lastSelection.id;
			
			setTimeout(()=>{
				
				this.draw.delete(id);
			}, 10);
		}
	}
	handleModeChange = (e)=>{
		console.log(e);
	}
	handleSelectionChange = (e)=>{
		if(!e.features.length){
			//remove all editable drawings and switch to view mode

			this.exit();
			this.roadModeForce();
			//this.tc.draw.drawRoads(this.scenario, this.tc);
			//issue exit command to refresh viewport (weird bug not deleting the pl linestring
			
		}
	}
	handleCursorChange = (e)=>{
		this.tc.map.getContainer().classList[e && e.type == 'mouseenter' ? 'add' : 'remove']("cursor-intersection");
		
	}
	handleMove = (e)=>{
		
		if(this.shouldMove(e)){
			
			clearInterval(this.moveTimeout);
			this.moveMap(this.moveFactor(e))
			this.moveTimeout = setInterval(()=>{this.moveMap(this.moveFactor(e));}, 10);
		}
		else {
			clearInterval(this.moveTimeout);
		}
		
	}
	moveFactor(e){
		
		const x = e.point.x;
		const y = e.point.y;
		
		const xFactor = ((x-this.hCenter)/this.hCenter)*this.moveSpeed;
		const yFactor = ((y-this.vCenter)/this.vCenter)*this.moveSpeed;
		
		return [xFactor, yFactor];
		
	}
	shouldMove(e){
		
		const x = e.point.x;
		const y = e.point.y;
		
		return (
			x <= this.lPad || 
			x >= this.rPad || 
			y <= this.tPad || 
			y >= this.bPad
		)
		
	}
	moveMap = (factor)=>{
		
		this.tc.map.panBy(factor, {duration: 0});
	}
	handleDelete = (e) => {
		if (e.features && e.features[0].id ){
			this.handleUpdate(e, e.features[0].id, true);
			this.removeBufferLayer();
		}
		this.exit();
		this.roadModeForce();
	}
	handleOnClose = (e)=>{
		this.exit();
		this.roadModeForce();
	}
	handleUpdate(e, pl, del){
		
		super.handleUpdate(e, pl, del);
		this.removeBufferLayer();
		
	}
	handleColorChange = (hex)=>{
		this.obj.color = hex;
		this.addBufferLayer();
		this.calculate();
		this.updateCurrentColor(hex);
	}
	handleNameChange = (name)=>{
		this.obj.name = name;
		this.calculate();
	}
	
	handleWidthChange = (width)=>{
		this.obj.width = width;
		this.calculate();
	}
	 
	openDrawPanel = ()=>{
		
		var wrp = document.createElement("div");
		wrp.className = "roadModePanel";
		
		this.closeDrawPanel();
		
		this.tc.map.getContainer().appendChild(wrp);
		

		ReactDOM.createRoot(wrp).render(<PowerRoadsPanel setup={{open:true, obj:this.obj, type:'Road'}} handler={this} onClose={this.handleOnClose} onDelete={this.handleDeleteFromPanel} onNameChange={this.handleNameChange} onColorChange={this.handleColorChange} onWidthChange={this.handleWidthChange} />	);
		
	}
	updateCurrentColor(color){
		var line;
		var mode = this.draw.getMode();
		
		var fs = this.draw.getAll();
		fs.features.forEach((f)=>{
			if(f.id == ToolRoad.lastSelection.id){
				f.properties.color = color;
			}
		})
		this.draw.set(fs);
		
	}
	calculate = () => {
		
		var line = false;
		
		if(this.draw.getMode() == 'road_mode')
			line = this.draw.get('added_road');
		else{
			line = this.draw.get(this.draw.getSelectedIds());
		}
	
		if(
			!line || 
			!line.geometry ||
			line.geometry?.coordinates?.length < 2
		)
			return;
		const r = (this.obj.width*0.997801)/2;
		const buffer = TurfBuffer(line, r, { units: 'meters'});

		this.tc.map.getSource(this.type+'_buffer').setData({
			type: 'FeatureCollection',
			features: [buffer]
		});
		
		// Calculate length and area
		this.length = TurfLength(line, { units: 'meters' });
		this.area = buffer ? TurfArea(buffer) - (Math.PI*(r*r)) : 0;
		this.display();
	}
	
	display = () => {
		if(this.tc.serviceBar.current)
			this.tabIndexAdd =	this.tc.serviceBar.current.inject(this.render(), this.tabIndexAdd);
	}
	render(){
		
		const {getters} = this.tc.draw.context;
		
		return (
			
			<div className={"project-roads "}>
				<div className="title">
					{this.obj.name}
					<span onClick={this.handleOnClose} className="btn btn-close alt float-end"><X size={16} /></span>
				</div>
				<div className="owner-body">

					<div className="separator">
						<span>About this road</span>
					</div>
					<div className="road-detail">
					
						<Row className="basic-info mb-2">
							<Col xs="12">
								<CarProfile size={16} />
								<span>Name: </span>
								
								{this.obj.name}
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<ArrowsOutLineVertical size={16} />
								<span>Length: </span>
								
								{this.length.toFixed(0)} m
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<ArrowsOutLineHorizontal size={16} />
								<span>Width: </span>
								
								{this.obj.width} m
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Bulldozer size={16} />
								<span>Affected area: </span>
								
								{formatArea(this.area, getters.user)}
							</Col>
						</Row>
					</div>

				</div>

			</div>	
			
		);
		
	}
}

export { ToolRoad, ToolRoadAdd};